(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orienx-brand-packaging"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ox-packaging-preview')) {
    customElements.define('ox-packaging-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.packagingReady) return;
        this.packagingReady = true;
        const trigger = this.querySelector('[data-ox-packaging-open]');
        const dialog = this.querySelector('[data-ox-packaging-dialog]');
        const close = this.querySelector('[data-ox-packaging-close]');
        if (!trigger || !dialog || !close || typeof dialog.showModal !== 'function') return;
        trigger.addEventListener('click', (event) => {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!dialog.open) dialog.showModal();
        });
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
